import React from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import bg from "../../assets/img/bg.svg";
import bttnicon from "../../assets/img/creat-post.svg";
import profile from "../../assets/img/user 1.svg";
import banner from "../../assets/img/Event.jpg";
import { API } from '../../services/api';
const EventTopBar = (props) => {
   const userData = JSON.parse(localStorage.getItem('userData'));
   const communityDetails = JSON.parse(localStorage.getItem('communityData'));
   
   return (
      <div>
         <div className="hd-breadcums">
            {props.page === "profile" ?
               <h3 className="main-heading"></h3> :
            <h3 className="main-heading">{communityDetails?.communityName}</h3>}
         </div>
         <div className="community-details">
            <div className='community_cover-img'>
               {userData.userType === "organization" ?
               (props.page === "profile" ?
               <img src={userData?.coverImage ? API.uploadFilePath + userData?.coverImage?.url : banner} alt="test" className="cover-bg-community" />:
              <img src={communityDetails?.coverImage?.url ? API.uploadFilePath + communityDetails?.coverImage?.url : banner} alt="test" className="cover-bg-community" /> )
               :<img src={communityDetails?.coverImage?.url ? API.uploadFilePath + communityDetails?.coverImage?.url : banner} alt="test" className="cover-bg-community" />}
               <div class="overlay"></div>
            </div>

            <div className="profile-div d-flex community-actions mb-5">
               <div class="community-icon-thumb">
                  {userData.userType === "organization" ?
                  (props.page === "profile" ?
                  <img src={userData?.profileImage?.url ? API.uploadFilePath + userData?.profileImage?.url :  profile} alt="test" className="community-detail-thumb" /> :
                  <img src={communityDetails?.profileImage?.url ? API.uploadFilePath + communityDetails?.profileImage?.url :  profile} alt="test" className="community-detail-thumb" />):
                  <img src={communityDetails?.profileImage?.url ? API.uploadFilePath + communityDetails?.profileImage?.url :  profile} alt="test" className="community-detail-thumb" />}
                  {props.page === "profile" ? 
                  <h3 className='community-details-name' ></h3> :
                  <h3 className='community-details-name' >{communityDetails?.communityName}</h3>}
               </div>


            </div>
         </div>
      </div>

   );


};
export default EventTopBar;